// Utils / constants
import { abbreviate } from 'NewAngular/utils/string-utils';
export const abbreviateUserDisplayName = (firstName, lastName, maxDisplayNameLength) => {
    const displayNameLength = firstName.length + lastName.length;
    // abbreviate display name if it exceeds max length
    let displayName;
    if (displayNameLength + 2 >= maxDisplayNameLength) {
        const abbreviationLength = Math.floor((maxDisplayNameLength - 2) / 2);
        displayName = `${abbreviate(lastName, abbreviationLength)}, ${abbreviate(firstName, abbreviationLength)}`;
    }
    else {
        displayName = `${lastName}, ${firstName}`;
    }
    return displayName;
};
